// extracted by mini-css-extract-plugin
module.exports = {"expandForceShow":"ChatExpandButton__expandForceShow__zM-tu","expand":"ChatExpandButton__expand__24SO6"};